import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/styles/index.css";
import reportWebVitals from "./reportWebVitals";
import { initAnalytics, track } from "./services/analytics";
import { isGranted } from "./services/consent";
import { initNativeShell } from "./native/capacitor";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Start analytics only if the user has previously granted consent. First-time
// (or previously-declined) visitors stay off until they accept in the banner,
// which calls initAnalytics() itself. Web Vitals / early events are buffered by
// the analytics layer and flushed on init if consent is later granted.
if (isGranted()) initAnalytics();

// Native shell setup on Capacitor (status bar, splash, deep links). No-op on web.
initNativeShell();

// NOTE (FE-14): CRA's Workbox service worker (`serviceWorkerRegistration`) is no
// longer generated under Vite. The native app doesn't need it. To restore the
// installable web PWA, add `vite-plugin-pwa` and register its worker here. The
// existing `public/manifest.json` and icons are unchanged and ready for it.

// Report Core Web Vitals (LCP, FID, CLS, FCP, TTFB) to analytics. CLS is a
// unitless ratio, so it's scaled to an integer; the rest are milliseconds.
reportWebVitals(({ name, value, id }) => {
  track("web_vitals", {
    metric_name: name,
    metric_id: id,
    value: Math.round(name === "CLS" ? value * 1000 : value),
  });
});
